import React, { useContext } from 'react';
import theme from '../theme/theme';
import { CORRECTFINAL8, CORRECTFINAL4, CORRECTFINAL } from '../assets/configs/constants'
import { randomString as generateRandomString } from '../utils';
import { globalStore } from '../state/store';
import { Avatar, Box, Divider, Grid, Menu, MenuItem, Typography } from '@mui/material';
import { updatePrediction } from '../services/predictionService';

import questionmark from '../assets/img/questionmark.png'


const RenderKnockoutTeamButton = ({team, pts, type, click, selecteable, final}) => {

    return (
        <Box sx={{
            width: '150px',
            backgroundColor: 
                ([CORRECTFINAL8].includes(pts) && final === "final8") ||
                ([CORRECTFINAL4].includes(pts) && final === "final4") ||
                ([CORRECTFINAL].includes(pts) && final === "final1") ? 
                    theme.palette.success.main :
                pts > 0 ?
                    theme.palette.primary.main :
                pts === 0 ?
                    theme.palette.error.main :
                Boolean(team.name) ? 
                    theme.palette.grey[800] : 
                selecteable ?
                    theme.palette.primary.contrastText :
                    theme.palette.grey[50],
            borderRadius: type === "home" ? '20px 20px 0px 0px' : '0px 0px 20px 20px',
            color: 
                Boolean(team.name) ? 
                    theme.palette.primary.contrastText : 
                selecteable ?
                    theme.palette.grey[800] :
                    theme.palette.grey[300],
            padding: '10px 15px 10px 15px',
            '&:hover': selecteable ? {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                cursor: 'pointer',
            } : {}
        }}
        onClick={selecteable ? click : e => null}
        >
            <Grid container direction="row" alignItems="center" justifyContent="flex-start">
                <Grid item>
                    <Avatar src={Boolean(team.flag) ? team.flag : questionmark} 
                    sx={{ width: '20px', height: '20px', opacity: selecteable || (Boolean(team) && Boolean(team.name)) ? '1.0' : '0.1'}} />
                </Grid>
                <Grid item>
                    <Typography sx={{fontSize: '13px', marginLeft: '10px', fontWeight: Boolean(team.name) ? 'bold' : 'normal'}} >
                        {Boolean(team.name) ? team.name : "Click to select"}
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    )
}

const KnockoutMatch = (props) => {

    const dayjs = require('dayjs')

    const [state, dispatch] = useContext(globalStore);
    const [anchorElSelectTeam, setAnchorElSelectTeam] = React.useState(null);
    const [teamOptions, setTeamOptions] = React.useState([])

    const match = Boolean(state.matches.filter((m) => m._id === props.matchID)[0]) ? 
            state.matches.filter((m) => m._id === props.matchID)[0] : {}
    const homeTeam = 
            Boolean(props.prediction) && Boolean(props.prediction.homeTeamID) &&
            Boolean(state.teams.filter((t) => t._id === props.prediction.homeTeamID)[0]) ? 
                state.teams.filter((t) => t._id === props.prediction.homeTeamID)[0] : {}
    const awayTeam = 
            Boolean(props.prediction) && Boolean(props.prediction.awayTeamID) &&
            Boolean(state.teams.filter((t) => t._id === props.prediction.awayTeamID)[0]) ? 
                state.teams.filter((t) => t._id === props.prediction.awayTeamID)[0] : {}
    const homePts = Boolean(props.prediction) && !isNaN(props.prediction.ptsh) ? props.prediction.ptsh : null
    const awayPts = Boolean(props.prediction) && !isNaN(props.prediction.ptsa) ? props.prediction.ptsa : null

    const handleOpenSelectTeamMenu = (event, side) => {
        setTeamOptions(['home'].includes(side) ? props.homeOptions : props.awayOptions)
        setAnchorElSelectTeam(event.currentTarget);
    };
      
    const handleCloseSelectTeamMenu = () => {
        setTeamOptions([])
        setAnchorElSelectTeam(null);
    };

    const handleSelectTeam = (newVal) => {

        let isHome = props.homeOptions.some((ho) => ho === newVal)
        // TODO: When you select a quarter final match - you need to select any 16th final match if they weren't manually selected/defined yet

        pushPrediction(
            props.prediction, 
            props.matchID, 
            match.stage,
            isHome ? newVal : Boolean(homeTeam._id) ? homeTeam._id : null,
            !isHome ? newVal : Boolean(awayTeam._id) ? awayTeam._id : null
        )

        /*
        if(match.stage === 'final1' && Boolean(state.matches.filter((m) => m.stage === 'final3')[0])){

            let thirdPlacePrediction = state.prediction.filter((p) => p.stage === 'final3')[0]
            let homeFinal3 = 
                    isHome && Boolean(props.homeOptions.filter((ho) => ho !== newVal)[0]) ?
                        props.homeOptions.filter((ho) => ho !== newVal)[0] :
                    Boolean(thirdPlacePrediction) && Boolean(thirdPlacePrediction.homeTeamID) ?
                        thirdPlacePrediction.homeTeamID :
                        null;
            let awayFinal3 = 
                    !isHome && Boolean(props.awayOptions.filter((ho) => ho !== newVal)[0]) ?
                        props.awayOptions.filter((ho) => ho !== newVal)[0] :
                    Boolean(thirdPlacePrediction) && Boolean(thirdPlacePrediction.awayTeamID) ?
                        thirdPlacePrediction.awayTeamID :
                        null;

            pushPrediction(
                thirdPlacePrediction, 
                state.matches.filter((m) => m.stage === 'final3')[0]._id,
                'final3',
                homeFinal3,
                awayFinal3
            )
        }*/
        
        handleCloseSelectTeamMenu()
    }

    const pushPrediction = async (prediction, matchID, stage, homeTeamID, awayTeamID) => {

        console.log("push1", prediction, matchID, stage, homeTeamID, awayTeamID)

        let newPredictionState = state.prediction
        let idx = newPredictionState.findIndex((p) => p.matchid === matchID);

        const newPrediction = { 
            _id: Boolean(prediction) && Boolean(prediction._id) ? prediction._id : generateRandomString(20), 
            matchid: matchID, 
            stage: stage,
            homeTeamID: homeTeamID, 
            awayTeamID: awayTeamID, 
        };

        if(idx !== -1){ // This is an update
            newPredictionState[idx] = newPrediction
        } else { // This is an add
            newPredictionState.push(newPrediction)
        }
        // Update state
        dispatch({
            type: idx !== -1 ? "UPDATE_PREDICTION" : "ADD_PREDICTION",
            payload: newPrediction,
        })

        // FAF the prediction
        updatePrediction({uid: state.user.uid, prediction: newPredictionState})
    }

    /*
    const updatePredictionAndDispatch = async () => {
        await dispatch({
            type: Boolean(prediction) && Boolean(prediction._id) ? "UPDATE_PREDICTION" : "ADD_PREDICTION",
            payload: { 
                _id: Boolean(prediction) && Boolean(prediction._id) ? prediction._id : generateRandomString(20), 
                matchid: matchID, 
                stage: stage,
                homeTeamID: homeTeamID, 
                awayTeamID: awayTeamID, 
            },
        });
        
        updatePrediction({ uid: state.user.uid, prediction: state.prediction });
    };*/


    return (
    <Box align="center">

        <Typography variant="body2" style={{color: theme.palette.grey[800]}}
        sx={{fontSize: '11px', padding: '10px 10px 5px 10px', textAlign: props.align, fontWeight: props.desc === 'Final' ? '900' : '300'}}>
            {props.desc}<br/>
            {dayjs(match.date).format('D MMM. h:mm A')}
        </Typography>

        <RenderKnockoutTeamButton
        team={homeTeam}
        pts={homePts}
        type="home"
        final={match.stage}
        selecteable={Boolean(props.homeOptions) && props.homeOptions.length > 0 && match.stage !== 'final3'}
        click={e => handleOpenSelectTeamMenu(e, 'home')}
        />

        <Divider sx={{width: '150px'}} />
    
        <RenderKnockoutTeamButton
        team={awayTeam}
        pts={awayPts}
        type="away"
        final={match.stage}
        selecteable={Boolean(props.awayOptions) && props.awayOptions.length > 0 && match.stage !== 'final3'}
        click={e => handleOpenSelectTeamMenu(e, 'away')}
        />

        <Menu
        //sx={{ mt: '40px' }}
        id="menu-appbar"
        anchorEl={anchorElSelectTeam}
        anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
        }}
        keepMounted
        transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
        }}
        open={Boolean(anchorElSelectTeam)}
        onClose={handleCloseSelectTeamMenu}
        >
        {teamOptions.map((to) => {

            let team = Boolean(state.teams.filter((t) => t._id === to)[0]) ? state.teams.filter((t) => t._id === to)[0] : {};

            return (
                <MenuItem key={to} style={{width: '170px', fontSize: '15px', fontWeight: '500', padding: '10px 20px'}}
                selected={[homeTeam._id, awayTeam._id].includes(to)}
                disabled={
                    state.closedForEditing ||
                    state.prediction.some((p) => p.matchid !== match._id && p.stage === match.stage && [p.homeTeamID, p.awayTeamID].includes(to))}
                onClick={e => handleSelectTeam(to)}>
                    <Avatar src={team.flag} style={{width: '25px', height: '25px', marginRight: '15px'}} /> {team.name}
                </MenuItem>
            )
        })}
        </Menu>
    </Box>
    );
};
export default KnockoutMatch;